import React from "react";

const COLORS = {
  ACTIVE: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  GRACE_PERIOD: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  SUSPENDED: "bg-rose-500/15 text-rose-300 border-rose-500/30",
  EXPIRED: "bg-slate-500/15 text-slate-300 border-slate-500/30",
  REVOKED: "bg-black/60 text-white/70 border-white/20",
};

const PLAN_COLORS = {
  STARTER: "bg-sky-500/15 text-sky-300 border-sky-500/30",
  GROWTH: "bg-purple-500/15 text-purple-300 border-purple-500/30",
  ENTERPRISE: "bg-amber-500/15 text-amber-300 border-amber-500/30",
};

export function LicenseStatusBadge({ status }) {
  const s = String(status || "ACTIVE").toUpperCase();
  const cls = COLORS[s] || COLORS.EXPIRED;
  return (
    <span className={`inline-flex items-center rounded-full border font-black uppercase tracking-wider text-[10px] px-2 py-0.5 ${cls}`}
      data-testid={`license-status-${s.toLowerCase()}`}>{s.replace("_", " ")}</span>
  );
}

export function PlanBadge({ plan }) {
  const p = String(plan || "STARTER").toUpperCase();
  const cls = PLAN_COLORS[p] || PLAN_COLORS.STARTER;
  return (
    <span className={`inline-flex items-center rounded-full border font-black uppercase tracking-wider text-[10px] px-2 py-0.5 ${cls}`}
      data-testid={`license-plan-${p.toLowerCase()}`}>{p}</span>
  );
}

export function EntitlementBadge({ enabled, label, testid }) {
  const cls = enabled ? "bg-emerald-500/15 text-emerald-300 border-emerald-500/30" : "bg-white/5 text-white/40 border-white/10";
  return (
    <span className={`inline-flex items-center rounded-full border font-bold text-[10px] px-2 py-0.5 ${cls}`} data-testid={testid}>
      {enabled ? "✓" : "✕"} {label}
    </span>
  );
}

export function formatQuota(v) {
  if (v === -1 || v === "-1") return "∞";
  if (v === null || v === undefined) return "—";
  return String(v);
}

export function formatKey(key) {
  if (!key) return "—";
  // display first 8 chars + ellipsis
  return key;
}
